import { render, staticRenderFns } from "./ScienceFilters.vue?vue&type=template&id=c66d3c88&"
import script from "./ScienceFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ScienceFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c66d3c88')) {
      api.createRecord('c66d3c88', component.options)
    } else {
      api.reload('c66d3c88', component.options)
    }
    module.hot.accept("./ScienceFilters.vue?vue&type=template&id=c66d3c88&", function () {
      api.rerender('c66d3c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/ScienceFilters/ScienceFilters.vue"
export default component.exports